import { Base } from '../base-component';

import './event-list-filter-year-topic.component.scss';

export class EventListFilterYearTopic extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/event-list-filter-year-topic/event-list-filter-year-topic.component.ts